<template>
    <generic-page>
        <h5 class="mt-3">
            {{ $t("Delete Account") }}
        </h5>
        <div v-if="selectedReason">
            <div v-if="resolution">
                <delete-resolution />
            </div>
            <div v-else-if="scheduled">
                <delete-scheduled />
            </div>
            <div v-else-if="undeleteable">
                <delete-manual />
            </div>
            <div v-else>
                <delete-confirmation />
            </div>
        </div>
        <div v-else>
            <delete-reason-index />
        </div>
    </generic-page>
</template>

<script>
import { mapState } from "vuex";

import DeleteConfirmation from "@/components/delete/DeleteConfirmation";
import DeleteManual from "@/components/delete/DeleteManual";
import DeleteReasonIndex from "@/components/delete/DeleteReasonIndex";
import DeleteResolution from "@/components/delete/DeleteResolution";
import DeleteScheduled from "@/components/delete/DeleteScheduled";

export default {
    mounted() {
        this.$store.commit("delete/reset");
    },
    computed: {
        ...mapState("delete", [
            "selectedReason",
            "scheduled",
            "undeleteable",
            "resolution",
        ]),
    },
    methods: {},
    components: {
        DeleteConfirmation,
        DeleteManual,
        DeleteReasonIndex,
        DeleteResolution,
        DeleteScheduled,
    },
};
</script>